// https://github.com/chakra-ui/chakra-ui/blob/main/packages/anatomy/src/index.ts

import palette from '@theme/assets/palette';

export const radio = {
    // The parts of the component
    parts: ['container', 'control', 'label'],
    // The styles all button have in common
    baseStyle: {
        control: {
            borderColor: palette.black,
            _checked: {
                borderColor: palette.black,
                bg: palette.white,
                color: palette.black,
                backgroundClip: 'content-box !important',
                _hover: {
                    borderColor: palette.black,
                    bg: palette.white,
                    color: palette.black,
                },
            },
            _focus: {
                borderColor: palette.black,
                bg: palette.white,
                color: palette.black,
            },
            _hover: {
                borderColor: palette.black,
                bg: palette.white,
                color: palette.black,
            },
        },
    },
    sizes: {},
    // Two variants: primary and outline
    variants: {},
    // The default size and variant values
    defaultProps: {},
};
